
// FEATURES
export const GET_FEATURES = "/features";
export const ADD_NEW_FEATURE = "/features";
export const UPDATE_FEATURE = "/features";
export const DELETE_FEATURE = "/features";


